import type { Idioma } from "./IdiomaProvider";

type Dicionario = Record<string, string>;

export const TEXTOS_AREA_CLIENTE: Record<Idioma, Dicionario> = {
  pt: {
    "Área do Cliente": "Área do Cliente",
    "Pedidos de Clientes": "Pedidos de Clientes",
    "Pedidos dos Clientes": "Pedidos dos Clientes",
    "Pedidos vinculados ao cadastro de cada cliente.": "Pedidos vinculados ao cadastro de cada cliente.",
    "Novo Pedido": "Novo Pedido",
    "Pedido": "Pedido",
    "Dados do pedido": "Dados do pedido",
    "Total do pedido": "Total do pedido",
    "Criar pedido": "Criar pedido",
    "Adicionar item": "Adicionar item",
    "Remover item": "Remover item",
    "Juros (%)": "Juros (%)",
    "Data do pedido": "Data do pedido",
    "Condição do cartão": "Condição do cartão",
    "À vista": "À vista",
    "Parcelado": "Parcelado",
    "Pedido enviado pelo cliente para análise e finalização pela equipe de vendas.": "Pedido enviado pelo cliente para análise e finalização pela equipe de vendas.",
    "Faça seu pedido para que a equipe de vendas já dê início ao seu atendimento e à separação dos itens.": "Faça seu pedido para que a equipe de vendas já dê início ao seu atendimento e à separação dos itens.",
    "Selecione os produtos e quantidades; empresa, cliente, data, juros e desconto são definidos pelo sistema.": "Selecione os produtos e quantidades; empresa, cliente, data, juros e desconto são definidos pelo sistema.",
    "O pedido fica pendente até a equipe de vendas revisar e finalizar.": "O pedido fica pendente até a equipe de vendas revisar e finalizar.",
    "Chamados dos Clientes": "Chamados dos Clientes",
    "Acompanhe os chamados abertos por clientes.": "Acompanhe os chamados abertos por clientes.",
    "Relatórios da Área do Cliente": "Relatórios da Área do Cliente",
    "Relatórios de clientes": "Relatórios de clientes",
    "Relatórios de pedidos e chamados dos clientes.": "Relatórios de pedidos e chamados dos clientes.",
    "Gerencie pedidos, chamados e relatórios dos clientes.": "Gerencie pedidos, chamados e relatórios dos clientes.",
    "Revise o pedido e informe os dados de entrega.": "Revise o pedido e informe os dados de entrega.",
    "Aprovar o pedido do cliente e registrar como ele será entregue.": "Aprovar o pedido do cliente e registrar como ele será entregue.",
    "Confira os itens e informe o prazo, a transportadora e o endereço de entrega.": "Confira os itens e informe o prazo, a transportadora e o endereço de entrega.",
    "Ao aprovar, o cliente verá o novo status e os dados de entrega no painel de detalhes.": "Ao aprovar, o cliente verá o novo status e os dados de entrega no painel de detalhes.",
    "Resumo do pedido": "Resumo do pedido",
    "Dados de entrega": "Dados de entrega",
    "O endereço de entrega é o mesmo do cadastro do cliente": "O endereço de entrega é o mesmo do cadastro do cliente",
    "Pedido aprovado com sucesso.": "Pedido aprovado com sucesso.",
    "Não foi possível aprovar o pedido.": "Não foi possível aprovar o pedido.",
    "Informe endereço, cidade, estado e prazo de entrega.": "Informe endereço, cidade, estado e prazo de entrega.",
    "Todos os estoques": "Todos os estoques",
    "Pesquisar estoque": "Pesquisar estoque",
    "Cidade/UF": "Cidade/UF",
  },
  en: {
    "Área do Cliente": "Customer Area",
    "Pedidos de Clientes": "Customer Orders",
    "Pedidos dos Clientes": "Customer Orders",
    "Pedidos vinculados ao cadastro de cada cliente.": "Orders linked to each customer record.",
    "Novo Pedido": "New Order",
    "Pedido": "Order",
    "Dados do pedido": "Order details",
    "Total do pedido": "Order total",
    "Criar pedido": "Create order",
    "Adicionar item": "Add item",
    "Remover item": "Remove item",
    "Juros (%)": "Interest (%)",
    "Data do pedido": "Order date",
    "Condição do cartão": "Card payment",
    "À vista": "Pay in full",
    "Parcelado": "Installments",
    "Pedido enviado pelo cliente para análise e finalização pela equipe de vendas.": "Order submitted by the customer for review and completion by the sales team.",
    "Faça seu pedido para que a equipe de vendas já dê início ao seu atendimento e à separação dos itens.": "Place your order so the sales team can start assisting you and preparing the items.",
    "Selecione os produtos e quantidades; empresa, cliente, data, juros e desconto são definidos pelo sistema.": "Select products and quantities; company, customer, date, interest, and discount are set by the system.",
    "O pedido fica pendente até a equipe de vendas revisar e finalizar.": "The order remains pending until the sales team reviews and completes it.",
    "Chamados dos Clientes": "Customer Tickets",
    "Acompanhe os chamados abertos por clientes.": "Track tickets opened by customers.",
    "Relatórios da Área do Cliente": "Customer Area Reports",
    "Relatórios de clientes": "Customer reports",
    "Relatórios de pedidos e chamados dos clientes.": "Customer order and ticket reports.",
    "Gerencie pedidos, chamados e relatórios dos clientes.": "Manage customer orders, tickets, and reports.",
    "Revise o pedido e informe os dados de entrega.": "Review the order and enter the delivery details.",
    "Aprovar o pedido do cliente e registrar como ele será entregue.": "Approve the customer order and record how it will be delivered.",
    "Confira os itens e informe o prazo, a transportadora e o endereço de entrega.": "Review the items and enter the delivery date, carrier, and address.",
    "Ao aprovar, o cliente verá o novo status e os dados de entrega no painel de detalhes.": "After approval, the customer will see the new status and delivery details in the details panel.",
    "Resumo do pedido": "Order summary",
    "Dados de entrega": "Delivery details",
    "O endereço de entrega é o mesmo do cadastro do cliente": "The delivery address is the same as the customer's registered address",
    "Pedido aprovado com sucesso.": "Order approved successfully.",
    "Não foi possível aprovar o pedido.": "The order could not be approved.",
    "Informe endereço, cidade, estado e prazo de entrega.": "Enter the address, city, state, and delivery date.",
    "Todos os estoques": "All warehouses",
    "Pesquisar estoque": "Search warehouse",
    "Cidade/UF": "City/State",
  },
  es: {
    "Área do Cliente": "Área del Cliente",
    "Pedidos de Clientes": "Pedidos de Clientes",
    "Pedidos dos Clientes": "Pedidos de los Clientes",
    "Pedidos vinculados ao cadastro de cada cliente.": "Pedidos vinculados al registro de cada cliente.",
    "Novo Pedido": "Nuevo Pedido",
    "Pedido": "Pedido",
    "Dados do pedido": "Datos del pedido",
    "Total do pedido": "Total del pedido",
    "Criar pedido": "Crear pedido",
    "Adicionar item": "Agregar artículo",
    "Remover item": "Eliminar artículo",
    "Juros (%)": "Intereses (%)",
    "Data do pedido": "Fecha del pedido",
    "Condição do cartão": "Condición de la tarjeta",
    "À vista": "Al contado",
    "Parcelado": "En cuotas",
    "Pedido enviado pelo cliente para análise e finalização pela equipe de vendas.": "Pedido enviado por el cliente para revisión y finalización por el equipo de ventas.",
    "Faça seu pedido para que a equipe de vendas já dê início ao seu atendimento e à separação dos itens.": "Realice su pedido para que el equipo de ventas pueda iniciar su atención y la preparación de los artículos.",
    "Selecione os produtos e quantidades; empresa, cliente, data, juros e desconto são definidos pelo sistema.": "Seleccione los productos y cantidades; la empresa, el cliente, la fecha, los intereses y el descuento son definidos por el sistema.",
    "O pedido fica pendente até a equipe de vendas revisar e finalizar.": "El pedido queda pendiente hasta que el equipo de ventas lo revise y finalice.",
    "Chamados dos Clientes": "Tickets de los Clientes",
    "Acompanhe os chamados abertos por clientes.": "Acompañe los tickets abiertos por clientes.",
    "Relatórios da Área do Cliente": "Informes del Área del Cliente",
    "Relatórios de clientes": "Informes de clientes",
    "Relatórios de pedidos e chamados dos clientes.": "Informes de pedidos y tickets de clientes.",
    "Gerencie pedidos, chamados e relatórios dos clientes.": "Gestione pedidos, tickets e informes de clientes.",
    "Revise o pedido e informe os dados de entrega.": "Revise el pedido e informe los datos de entrega.",
    "Aprovar o pedido do cliente e registrar como ele será entregue.": "Aprobar el pedido del cliente y registrar cómo se entregará.",
    "Confira os itens e informe o prazo, a transportadora e o endereço de entrega.": "Revise los artículos e informe la fecha, el transportista y la dirección de entrega.",
    "Ao aprovar, o cliente verá o novo status e os dados de entrega no painel de detalhes.": "Al aprobar, el cliente verá el nuevo estado y los datos de entrega en el panel de detalles.",
    "Resumo do pedido": "Resumen del pedido",
    "Dados de entrega": "Datos de entrega",
    "O endereço de entrega é o mesmo do cadastro do cliente": "La dirección de entrega es la misma del registro del cliente",
    "Pedido aprovado com sucesso.": "Pedido aprobado correctamente.",
    "Não foi possível aprovar o pedido.": "No se pudo aprobar el pedido.",
    "Informe endereço, cidade, estado e prazo de entrega.": "Informe la dirección, ciudad, estado y fecha de entrega.",
    "Todos os estoques": "Todos los almacenes",
    "Pesquisar estoque": "Buscar almacén",
    "Cidade/UF": "Ciudad/Estado",
  },
  "zh-CN": {
    "Área do Cliente": "客户专区",
    "Pedidos de Clientes": "客户订单",
    "Pedidos dos Clientes": "客户订单",
    "Pedidos vinculados ao cadastro de cada cliente.": "与每个客户档案关联的订单。",
    "Novo Pedido": "新建订单",
    "Pedido": "订单",
    "Dados do pedido": "订单信息",
    "Total do pedido": "订单总额",
    "Criar pedido": "创建订单",
    "Adicionar item": "添加项目",
    "Remover item": "删除项目",
    "Juros (%)": "利息 (%)",
    "Data do pedido": "订单日期",
    "Condição do cartão": "银行卡付款方式",
    "À vista": "一次性付款",
    "Parcelado": "分期付款",
    "Pedido enviado pelo cliente para análise e finalização pela equipe de vendas.": "客户提交的订单将由销售团队审核并完成。",
    "Faça seu pedido para que a equipe de vendas já dê início ao seu atendimento e à separação dos itens.": "提交您的订单，以便销售团队立即开始为您服务并准备商品。",
    "Selecione os produtos e quantidades; empresa, cliente, data, juros e desconto são definidos pelo sistema.": "请选择产品和数量；公司、客户、日期、利息和折扣由系统设定。",
    "O pedido fica pendente até a equipe de vendas revisar e finalizar.": "订单将保持待处理状态，直到销售团队审核并完成。",
    "Chamados dos Clientes": "客户工单",
    "Acompanhe os chamados abertos por clientes.": "跟踪客户提交的工单。",
    "Relatórios da Área do Cliente": "客户专区报表",
    "Relatórios de clientes": "客户报表",
    "Relatórios de pedidos e chamados dos clientes.": "客户订单和工单报表。",
    "Gerencie pedidos, chamados e relatórios dos clientes.": "管理客户订单、工单和报表。",
    "Revise o pedido e informe os dados de entrega.": "请检查订单并填写配送信息。",
    "Aprovar o pedido do cliente e registrar como ele será entregue.": "批准客户订单并记录配送方式。",
    "Confira os itens e informe o prazo, a transportadora e o endereço de entrega.": "请检查商品并填写配送日期、承运商和地址。",
    "Ao aprovar, o cliente verá o novo status e os dados de entrega no painel de detalhes.": "批准后，客户将在详情面板中看到新状态和配送信息。",
    "Resumo do pedido": "订单摘要",
    "Dados de entrega": "配送信息",
    "O endereço de entrega é o mesmo do cadastro do cliente": "配送地址与客户登记地址相同",
    "Pedido aprovado com sucesso.": "订单批准成功。",
    "Não foi possível aprovar o pedido.": "无法批准订单。",
    "Informe endereço, cidade, estado e prazo de entrega.": "请填写地址、城市、州和配送日期。",
    "Todos os estoques": "所有仓库",
    "Pesquisar estoque": "搜索仓库",
    "Cidade/UF": "城市/州",
  },
};
